module.exports = __webpack_public_path__ + "static/media/01.9fb5a300.png";